import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as Reference from "../store/ducks/reference.duck";
import * as Admin from "../store/ducks/admin.duck";
import { Scheduler, WeekView, MonthView, DayView, SchedulerItem, SchedulerItemContent } from "@progress/kendo-react-scheduler";
// import { Modal } from "react-bootstrap";
import { FormWithCustomEditor } from "./scheduler/custom-form";
import { IntlProvider, load, loadMessages, LocalizationProvider } from "@progress/kendo-react-intl";
import { guid } from "@progress/kendo-react-common";
import { Modal, Button, Form } from "react-bootstrap";
import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import currencyData from "cldr-core/supplemental/currencyData.json";
import weekData from "cldr-core/supplemental/weekData.json";
import numbers from "cldr-numbers-full/main/en-AU/numbers.json";
import currencies from "cldr-numbers-full/main/en-AU/currencies.json";
import caGregorian from "cldr-dates-full/main/en-AU/ca-gregorian.json";
import dateFields from "cldr-dates-full/main/en-AU/dateFields.json";
import { Day } from "@progress/kendo-date-math";
import { parseISO, differenceInMinutes } from "date-fns";
import PhoneIcon from "@material-ui/icons/Phone";
import BookingOutcome from "./BookingOutcome";
import { ToastContainer, Flip } from "react-toastify";
import { Grid, Checkbox } from "@material-ui/core";
import { format } from "date-fns";

import "../../_metronic/_assets/css/app2.css";
import { bookingLocation } from "./scheduler/data";

load(likelySubtags, currencyData, weekData, numbers, currencies, caGregorian, dateFields);

const displayDate = new Date();

export default function AvailabilityNew({ mainID, fullName, userTZ, providerType, currentFundingTypes }) {
  const dispatch = useDispatch();
  // const registered = useSelector(state => state.admin.RegisteredPsychologists[0]);
  const bookings = useSelector((state) => state.admin.ProviderBookings);
  const availability = useSelector((state) => state.admin.Availability);
  const clients = useSelector((state) => state.admin.Clients);
  const [showAttendanceDialog, setShowAttendanceDialog] = useState(false);
  const [attendanceData, setAttendanceData] = useState(null);
  const [attendanceStatus, setAttendanceStatus] = useState(null);
  const [showCancelProviderBooking, setShowCancelProviderBooking] = useState(false);
  const [cancelBookingData, setCancelBookingData] = useState(null);
  const [cancellationTypeSMS, setCancellationTypeSMS] = useState(false);
  const [cancellationReason, setCancellationReason] = useState();
  const [cancellationType, setCancellationType] = useState("");
  const [cancellationTypeSMSText, setCancellationTypeSMSText] = useState("");
  const [booking, setBooking] = useState(null);
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const schedulerMessages = {
    "scheduler.deleteConfirmation": "Are you sure you want to cancel this booking?",
    "scheduler.editorDelete": "Cancel Booking",
    "scheduler.deleteTitle": "Cancel",
    "scheduler.deleteDialogTitle": "Cancel Booking",
  };

  loadMessages(schedulerMessages, "en-AU");

  useEffect(() => {
    dispatch(Reference.actions.fetchTimeZone());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchConstants());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchFundingTypes());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchBookingTypeStatistics());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchClients({ status: "Active", providerId: mainID, type: providerType }));
  }, [dispatch, mainID, providerType]);

  useEffect(() => {
    if (mainID) {
      dispatch(Admin.actions.fetchBookings({ key: "psychologist", id: mainID }));
      dispatch(Admin.actions.fetchAvailability({ psychologistid: mainID, userTZ }));
    }
  }, [dispatch, mainID, userTZ]);

  function cancelBooking(id) {
    // Need to handle no show which is triggered if it is save by a provider and reason is not selected - it is like the multiverse
    if (cancellationType === "NoShow") {
      // Update database as client did not show
      dispatch(
        Admin.actions.putAppointment({
          id: id,
          status: "NoShow",
          cancellationReason: cancellationReason,
          refreshPayload: { key: "psychologist", id: registered.id },
        }),
      );
      // Update local display
      setBooking({ ...booking, status: "NoShow" });
      if (cancellationTypeSMS && cancellationTypeSMSText && cancellationTypeSMSText.length > 10) {
        const formData = new FormData();
        formData.append("type", "Client");
        formData.append("pkid", booking.clientID);
        formData.append("subject", "");
        formData.append("selector", "SMS");
        formData.append("note", cancellationTypeSMSText);
        formData.append("faxdestination", "");
        formData.append("faxFile", "");
        formData.append("sendFormID", 0);
        // Ok Time to Dispatch
        process.env.REACT_APP_DEBUG && console.log(...formData);
        dispatch(
          Admin.actions.postNote({
            formData: formData,
            type: "Client",
            pkID: booking.clientID,
          }),
        );
      }
    } else {
      if (cancellationType === "LateCancel") {
        dispatch(
          Admin.actions.putAppointment({
            id: id,
            status: "LateCancel",
            cancellationReason: cancellationReason,
            refreshPayload: { key: "psychologist", id: mainID },
          }),
        );
        // Update local display
        setBooking({ ...booking, status: "LateCancel" });
      } else {
        if (cancellationType === "LateCancelProvider") {
          dispatch(
            Admin.actions.putAppointment({
              id: id,
              status: "LateCancelProvider",
              cancellationReason: cancellationReason,
              refreshPayload: { key: "psychologist", id: mainID },
            }),
          );
          // Update local display
          setBooking({ ...booking, status: "LateCancelProvider" });
        } else {
          // Update database as booking cancelled by provider
          dispatch(
            Admin.actions.putAppointment({
              id: id,
              status: "Cancelled",
              cancellationReason: cancellationReason,
              refreshPayload: { key: "psychologist", id: mainID },
            }),
          );
          // Update local display
          setBooking({ ...booking, status: "Cancelled" });
        }
      }
    }
    // Close provider booking cancel modal - if open
    setShowCancelProviderBooking(false);
  }

  const LEGEND_ITEMS = [
    {
      label: "Availability - General",
      color: "#287844",
    },
    {
      label: "Availability - NthQLDPHN",
      color: "#70409A",
    },
    {
      label: "Availability - Supervision",
      color: "#285F96",
    },
    {
      label: "Unavailable",
      color: "#A83D36",
    },
    {
      label: "Booking - Provisional",
      color: "#FFC0CB",
    },
    {
      label: "Booking - Bulk Billed",
      color: "#133b0a",
    },
    {
      label: "Booking - NDIS",
      color: "#672771",
    },
    {
      label: "Booking - Reduced Gap",
      color: "#6acccc",
    },
    {
      label: "Booking - Contract",
      color: "#256A87",
    },
    {
      label: "Booking - EAP",
      color: "#FFC5D0",
    },
    {
      label: "Booking - Full Fee",
      color: "#cfb94a",
    },
    {
      label: "Booking - TAC",
      color: "#f6c324",
    },
    {
      label: "Booking - WorkCover",
      color: "#f6c324",
    },
    {
      label: "Booking - DVA",
      color: "#f6c324",
    },
    {
      label: "Booking - Island",
      color: "#6acccc",
    },
  ];

  const availabilityItems = LEGEND_ITEMS.filter((x) => x.label.startsWith("Availability") || x.label === "Unavailable");

  const bookingItems = LEGEND_ITEMS.filter((x) => x.label.startsWith("Booking"));

  const LegendItem = ({ item }) => {
    const swatchStyle = item.striped
      ? {
          background: `repeating-linear-gradient(
          45deg,
          ${item.color1},
          ${item.color1} 10px,
          ${item.color2} 10px,
          ${item.color2} 20px
        )`,
        }
      : {
          backgroundColor: item.color,
        };

    return (
      <div className="scheduler-legend-item">
        <span className="scheduler-legend-swatch" style={swatchStyle} />
        <span>{item.label}</span>
      </div>
    );
  };

  const SchedulerLegend = () => {
    return (
      <div className="scheduler-legend">
        <div className="scheduler-legend-title">Calendar Legend</div>

        <div className="scheduler-legend-sections">
          {/* AVAILABILITY */}
          <div className="scheduler-legend-section">
            <div className="scheduler-legend-heading">Availability</div>

            <div className="scheduler-legend-grid">
              {availabilityItems.map((item) => (
                <LegendItem key={item.label} item={item} />
              ))}
            </div>
          </div>

          {/* BOOKINGS */}
          <div className="scheduler-legend-section">
            <div className="scheduler-legend-heading">Bookings</div>

            <div className="scheduler-legend-grid">
              {bookingItems.map((item) => (
                <LegendItem key={item.label} item={item} />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const SchedulerLegendContainer = () => {
    const [showLegend, setShowLegend] = useState(false);

    return (
      <div className="scheduler-legend-container">
        <div className="scheduler-legend-toolbar">
          <button type="button" className="scheduler-legend-button" onClick={() => setShowLegend(!showLegend)}>
            {showLegend ? "Hide Legend" : "Show Legend"}
          </button>
        </div>

        {showLegend && (
          <div className="scheduler-legend-panel">
            <SchedulerLegend />
          </div>
        )}
      </div>
    );
  };

  // Assemble data from bookings and availability
  const newBookings = bookings
    .filter((r) => r.status !== "Cancelled" && r.status !== "LateCancelProvider")
    .map((row) => {
      return {
        id: row.id,
        clientID: row.clientID,
        eventType: "booking",
        title: row.clientfullname,
        start: parseISO(row.startDate),
        end: parseISO(row.endDate),
        note: row.note,
        paymentType: row.paymentType,
        bookingType: row.bookingType,
        bookingCode: row.bookingCode,
        bookingLocation: row.bookingLocation,
        status: row.status,
        contactMobilePhone: row.contactMobilePhone,
        showTodoIcon: row.toDoCount !== 0 ? true : false,
        appointmenttype: row.appointmenttype,
        contractId: row.contractId,
        days: row.days,
        bulkBillingFormStatus: row.bulkBillingFormStatus,
      };
    });

  const newAvailability = availability.map((row) => {
    const atype = row.atype || "Availability";
    const clientType = row.client_type || "All";
    const label = row.label || "";

    // Generate the display title
    let availabilityTypeDisplay = "";

    switch (atype) {
      case "Availability": {
        const programs = [];

        if (row.program_Medicare_General) programs.push("Medicare");
        if (row.program_NDIS) programs.push("NDIS");
        if (row.program_CentralisedService) programs.push("Centralised Service");
        if (row.program_EAP) programs.push("EAP");
        if (row.program_Perinatal) programs.push("Perinatal");
        if (row.program_Group) programs.push("Group");

        availabilityTypeDisplay = `Available - ${clientType}`;

        if (programs.length > 0) {
          availabilityTypeDisplay += ` (${programs.join(", ")})`;
        }

        break;
      }

      case "Unavailable":
        availabilityTypeDisplay = row.label?.trim() ? `Unavailable - ${row.label.trim()}` : "Unavailable";
        break;

      case "Supervision":
        availabilityTypeDisplay = "Supervision";
        break;

      case "NthQLDPHN":
        availabilityTypeDisplay = "Nth QLD PHN";
        break;

      default:
        availabilityTypeDisplay = "Availability";
        break;
    }

    return {
      id: row.id,

      // All availability records use the same event type
      eventType: atype,
      label: label,
      psychologistID: row.psychologistID,

      // New availability fields
      atype: atype,
      client_type: clientType,

      Program_Medicare_General: Boolean(row.program_Medicare_General),
      Program_NDIS: Boolean(row.program_NDIS),
      Program_CentralisedService: Boolean(row.program_CentralisedService),
      Program_EAP: Boolean(row.program_EAP),
      Program_Perinatal: Boolean(row.program_Perinatal),
      Program_Group: Boolean(row.program_Group),
      // Display title
      title: availabilityTypeDisplay,

      // Dates
      start: parseISO(row.startDate),
      end: parseISO(row.endDate),

      // Recurrence
      recurrenceRule: row.rRule && row.rRule.length > 0 ? row.rRule.replace("RRULE:", "") : undefined,

      recurrenceExceptions:
        row.exDate && row.exDate.length > 0 ? row.exDate.split(",").map((item) => (item.length === 16 ? parseISO(item) : new Date(item))) : [],
    };
  });

  const items = React.useMemo(() => {
    return [...newBookings, ...newAvailability];
  }, [bookings, availability]);

  // create ref to vars we need to submit with actions, so we can fetch the vales after they have been set by useEffect
  const payloadParams = {
    psychologistID: mainID,
    userTZ: userTZ,
  };

  const payloadRef = useRef(payloadParams);
  useEffect(() => {
    payloadRef.current = payloadParams;
  }, [payloadParams]);

  // Custom item to apply colour for bookings/paymentType vs. availability
  const CustomItem = (props) => {
    let backgroundStyles = {};

    const item = props.dataItem;
    if (item.eventType === "Availability" || item.eventType === "Unavailable" || item.eventType === "Supervision" || item.eventType === "NthQLDPHN") {
      switch (item.atype) {
        case "Availability":
          backgroundStyles = { backgroundColor: "#287844" };
          break;

        case "Supervision":
          backgroundStyles = { backgroundColor: "#285F96" };
          break;

        case "NthQLDPHN":
          backgroundStyles = { backgroundColor: "#70409A" };
          break;

        case "Unavailable":
          backgroundStyles = { backgroundColor: "#A83D36" };
          break;

        default:
          backgroundStyles = { backgroundColor: "blue" };
          break;
      }
    }
    // Preserve existing booking payment-type colours.
    switch (item.paymentType) {
      case "Provisional":
        backgroundStyles = { backgroundColor: "#FFC0CB" };
        break;
      case "Bulk Billed":
        backgroundStyles = { backgroundColor: "#133b0a" };
        break;
      case "NDIS":
        backgroundStyles = { backgroundColor: "#672771" };
        break;
      case "Reduced Gap":
        backgroundStyles = { backgroundColor: "#6acccc" };
        break;
      case "Contract":
        backgroundStyles = { backgroundColor: "#256A87" };
        break;
      case "EAP":
        backgroundStyles = { backgroundColor: "#FFC5D0" };
        break;
      case "Full Fee":
        backgroundStyles = { backgroundColor: "#cfb94a" };
        break;
      case "TAC":
      case "WorkCover":
      case "DVA":
        backgroundStyles = { backgroundColor: "#f6c324" };
        break;
      default:
        break;
    }

    const customStyles = { ...backgroundStyles, fontSize: 12 };

    return (
      <SchedulerItem {...props} style={{ ...props.style, ...customStyles }}>
        {props.children}

        {item.eventType === "booking" && item.appointmenttype === "1" ? (
          <SchedulerItemContent>
            <PhoneIcon />
          </SchedulerItemContent>
        ) : null}
      </SchedulerItem>
    );
  };

  // We manage both local state and redux state, to make the UI more responsive and not wait for redux.
  // data = local state, updated directly by change events - the calendar displays from this array
  // items = redux state, updated via actions. We only update local from this once the items != prevItems (i.e. redux has changed)
  // So, the sequence is update => update data => send action => items get updated from redux => is now different to prevItems => update data (again) with fresh copy from items
  const [data, setData] = React.useState([]);

  useEffect(() => {
    setData(items);
  }, [items]);

  function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  const getUpdateTitle = (item) => {
    switch (item.eventType) {
      case "Availability":
        return "Availability";
      case "Unavailable":
        return "Unavailable";
      case "Supervision":
        return "Supervision";
      case "NthQLDPHN":
        return "Nth QLD PHN";
      default:
        return clients.find((row) => row.id === parseInt(item.clientID)).fullname;
    }
  };

  const limitInfiniteRecurrence = (item) => {
    const rule = item.recurrenceRule || item.rRule;

    if (!rule) {
      return item;
    }

    // A recurrence with COUNT or UNTIL already has an end condition.
    if (/(?:^|;)(COUNT|UNTIL)=/i.test(rule)) {
      return item;
    }

    // No COUNT or UNTIL means the recurrence has no defined end.
    const updatedRule = `${rule};COUNT=10`;

    return {
      ...item,
      ...(item.recurrenceRule !== undefined ? { recurrenceRule: updatedRule } : {}),
      ...(item.rRule !== undefined ? { rRule: updatedRule } : {}),
    };
  };

  const buildAvailabilityPayload = (item, isNew = false) => ({
    ...(isNew
      ? {}
      : {
          slot: item.id,
          id: item.id,
        }),

    mainID: payloadRef.current.psychologistID,
    label: item.label || "",
    startDate: item.start,
    endDate: item.end,
    title: item.title,
    allDay: false,
    rRule: item.recurrenceRule,
    exDate: item.recurrenceExceptions ? item.recurrenceExceptions.map((date) => (date instanceof Date ? date.toISOString() : date)).join(", ") : "",
    userTZ: payloadRef.current.userTZ,

    // New availability fields
    atype: item.eventType || "Availability",
    client_type: item.client_type || "All",
    Program_Medicare_General: Boolean(item.Program_Medicare_General),
    Program_NDIS: Boolean(item.Program_NDIS),
    Program_CentralisedService: Boolean(item.Program_CentralisedService),
    Program_EAP: Boolean(item.Program_EAP),
    Program_Perinatal: Boolean(item.Program_Perinatal),
    Program_Group: Boolean(item.Program_Group),
  });

  const handleDataChange = (props) => {
    setData((old) =>
      old
        .filter(
          (item) =>
            props.deleted.find((current) => current.id === item.id) === undefined &&
            props.updated.find((current) => current.id === item.id && current.status === "Cancelled") === undefined,
        )
        .map((item) => props.updated.find((current) => current.id === item.id) || item)
        .concat(
          props.created.map((item) =>
            Object.assign({}, item, {
              id: guid(),
              title: getUpdateTitle(item), // get the proper title to display (e.g. client fullname for bookings)
            }),
          ),
        ),
    );
    var payload = {};
    var duration = 0;
    // Updated
    if (props.updated.length > 0) {
      const changed = props.updated[0];
      if (
        changed.eventType === "Availability" ||
        changed.eventType === "Unavailable" ||
        changed.eventType === "Supervision" ||
        changed.eventType === "NthQLDPHN"
      ) {
        const payload = buildAvailabilityPayload(changed);
        dispatch(Admin.actions.chgAvailability(payload));
      } else if (changed.eventType === "booking") {
        // If the event being changed has recently been created and has not saved, it has a GUID for an ID and cannot be changed by the API - thus bounce it
        if (isNumeric(changed.id)) {
          duration = differenceInMinutes(new Date(changed.end), new Date(changed.start));
          var status = changed.status === "Active" || changed.status === "Attended" ? "Updated" : changed.status;
          payload = {
            id: changed.id,
            status: status,
            appointment: {
              id: changed.id,
              userTZ: "UTC", //done
              startDate: changed.start,
              duration: duration,
              clientID: changed.clientID, // done
              psychologistID: payloadRef.current.psychologistID, // done
              note: changed.note,
              paymentType: changed.paymentType,
              bookingType: changed.bookingType,
              bookingCode: changed.bookingCode,
              bookingLocation: changed.bookingLocation,
              status: status,
            },
            refreshPayload: {
              key: "psychologist",
              id: payloadRef.current.psychologistID,
            },
          };
          dispatch(Admin.actions.putAppointment(payload));
        }
      }
    }
    // Added
    if (props.created.length > 0) {
      const added = props.created[0];
      if (added.eventType === "Availability" || added.eventType === "Unavailable" || added.eventType === "Supervision" || added.eventType === "NthQLDPHN") {
        const payload = buildAvailabilityPayload(added, true);
        dispatch(Admin.actions.addAvailability(payload));
      } else if (added.eventType === "booking") {
        duration = differenceInMinutes(new Date(added.end), new Date(added.start));
        payload = {
          timezone: "UTC", //done
          newbookingdate: added.start,
          duration: duration,
          clientID: added.clientID, // done
          psychologistID: payloadRef.current.psychologistID, // done
          note: added.note,
          paymentType: added.paymentType,
          bookingType: added.bookingType,
          bookingCode: added.bookingCode,
          bookingLocation: added.bookingLocation,
          refreshPayload: {
            key: "psychologist",
            id: payloadRef.current.psychologistID,
          },
          source: "ProviderPortal",
        };
        dispatch(Admin.actions.bookAppointment(payload));
      }
    }
    // Deleted
    if (props.deleted.length > 0) {
      const deleted = props.deleted[0];

      if (
        deleted.eventType === "Availability" ||
        deleted.eventType === "Unavailable" ||
        deleted.eventType === "Supervision" ||
        deleted.eventType === "NthQLDPHN"
      ) {
        const payload = {
          slot: deleted.id,
          mainID: payloadRef.current.psychologistID,
          userTZ: payloadRef.current.userTZ,
        };

        dispatch(Admin.actions.delAvailability(payload));
      } else if (deleted.eventType === "booking") {
        // Keep your existing booking cancellation logic here, unchanged.
        dispatch(
          Admin.actions.putAppointment({
            id: deleted.id,
            status: "Cancelled",
            appointment: {
              id: deleted.id,
              userTZ: "UTC", //done
              startDate: deleted.start,
              clientID: deleted.clientID, // done
              psychologistID: payloadRef.current.psychologistID, // done
              status: status,
            },
            refreshPayload: {
              key: "psychologist",
              id: payloadRef.current.psychologistID,
            },
          }),
        );
      }
    }
  };

  const handleSchedulerDataChange = (props) => {
    if (props.deleted?.length > 0) {
      const deleted = props.deleted[0];

      if (deleted.eventType === "booking") {
        // Check if it is CS Booking
        console.log("Deleted booking:", deleted);
        if (deleted.contractId === "15") {
          // It is a CS Booking
          setAttendanceData(deleted);
          setAttendanceStatus(deleted.days);
          setShowAttendanceDialog(true);
        } else {
          // Non-CS Booking
          const client = clients.find((row) => row.id === parseInt(deleted.clientID));
          var bookingData = {
            id: deleted.id,
            clientfullname: deleted.title,
            psychologistfullname: fullName,
            psychologistDate: deleted.start,
            clientID: deleted.clientID,
            paymentType: deleted.paymentType,
            bookingType: deleted.bookingType,
            sessionType: deleted.bookingCode,
            bookingLocation: deleted.bookingLocation,
          };
          setCancellationTypeSMSText(
            `Hello ${client && client.preferredname && client.preferredname.length > 0 ? client.preferredname : client.firstname}, you were scheduled to have an appointment with Rural Health Conect. If you had problems connecting, need assistance or wish to rebook please email referrals@ruralhealthconnect.com.au or call the phone number on our wesbite.`,
          );
          setCancelBookingData(bookingData);
          // Open Provider Cancel Modal
          setShowCancelProviderBooking(true);
        }
        // IMPORTANT:
        // Do not call handleDataChange().
        // This prevents the booking from being deleted.
        return;
      }
    }

    // Automatically limit indefinite availability recurrences to 10 occurrences.
    const updatedProps = {
      ...props,
      created: (props.created || []).map((item) => (item.eventType === "availability" ? limitInfiniteRecurrence(item) : item)),
      updated: (props.updated || []).map((item) => (item.eventType === "availability" ? limitInfiniteRecurrence(item) : item)),
    };

    // Everything else behaves exactly as it does currently
    handleDataChange(updatedProps);
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="kt-portlet kt-portlet--height-fluid">
            <div className="kt-portlet__body" style={{ padding: 0 }}>
              <div className="kt-widget4">
                <LocalizationProvider language="en-AU">
                  <IntlProvider locale="en-AU" messages={schedulerMessages}>
                    <SchedulerLegendContainer />
                    <Scheduler
                      data={data}
                      onDataChange={handleSchedulerDataChange}
                      timezone={userTimeZone}
                      item={CustomItem}
                      defaultDate={displayDate}
                      defaultView="week"
                      editable={{
                        add: true,
                        drag: true,
                        resize: true,
                        edit: true,
                        remove: true,
                      }}
                      form={(props) => <FormWithCustomEditor {...props} psychologistId={mainID} />}
                      // header={CustomHeader}
                      height={900}
                    >
                      <DayView slotDuration={60} slotDivisions={4} />
                      <WeekView
                        title="Week"
                        workDayStart="06:00"
                        workDayEnd="22:00"
                        selectedDateFormat="{0:M}"
                        selectedShortDateFormat="{0:M}"
                        workWeekStart={Day.Monday}
                        slotDuration={60}
                        slotDivisions={4}
                      />
                      <MonthView />
                    </Scheduler>
                  </IntlProvider>
                </LocalizationProvider>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Modal
        show={showAttendanceDialog}
        onHide={() => setShowAttendanceDialog(false)}
        size="lg" // "sm" | "lg" | "xl"
        dialogClassName="note-modal"
        style={{ zIndex: 1150 }}
        centered
      >
        <Modal.Header closeButton className="notes-modal">
          <Modal.Title>Booking with {attendanceData && attendanceData.title ? attendanceData.title : ""}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="notes-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
          <BookingOutcome
            name={attendanceData && attendanceData.title ? attendanceData.title : ""}
            start={attendanceData && attendanceData.start ? attendanceData.start : null}
            end={attendanceData && attendanceData.end ? attendanceData.end : null}
            status={attendanceData && attendanceData.status ? attendanceData.status : ""}
            clientID={attendanceData && attendanceData.clientID ? attendanceData.clientID : null}
            bookingID={attendanceData && attendanceData.id ? attendanceData.id : null}
            contractId={attendanceData && attendanceData.contractId ? attendanceData.contractId : null}
            paymentType={attendanceData && attendanceData.paymentType ? attendanceData.paymentType : ""}
            psychologistID={mainID}
            attendanceStatus={attendanceStatus}
            closeModal={setShowAttendanceDialog}
            source="Calendar"
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showCancelProviderBooking}
        onHide={() => setShowCancelProviderBooking(false)}
        dialogClassName="new-bookingDialog-modal"
        style={{ zIndex: 1150 }}
        centered
      >
        <Modal.Header closeButton className="new-booking-modal">
          <Modal.Title>Booking with {cancelBookingData && cancelBookingData.clientfullname ? cancelBookingData.clientfullname : ""}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="new-booking-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
          <Grid container spacing={3}>
            <Grid item md={3} xs={6}>
              Client:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {cancelBookingData && cancelBookingData.clientfullname ? cancelBookingData.clientfullname : ""}
            </Grid>
            <Grid item md={3} xs={6}>
              Date:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {cancelBookingData && cancelBookingData.psychologistDate ? format(new Date(cancelBookingData.psychologistDate), "dd-MM-yyyy") : ""}
            </Grid>
            <Grid item md={3} xs={6}>
              Time:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {cancelBookingData && cancelBookingData.psychologistDate ? format(new Date(cancelBookingData.psychologistDate), "h:mm aa") : ""}
            </Grid>
            <Grid item md={3} xs={6}>
              Payment Type:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {cancelBookingData && cancelBookingData.paymentType ? cancelBookingData.paymentType : ""}
            </Grid>
            <hr />
            <Grid item md={12} xs={6}>
              <Form.Group>
                <Form.Label style={{ fontWeight: 600, paddingBottom: 10 }}>Why is this booking being cancelled?</Form.Label>
                <Form.Check id="cancellationType-NoShow" name="noShowCancellation" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="NoShow"
                    type="radio"
                    checked={cancellationType === "NoShow" ? true : false}
                    onChange={(e) => setCancellationType("NoShow")}
                  />
                  <Form.Check.Label style={{ marginLeft: 12 }}>Client did not attend </Form.Check.Label>
                </Form.Check>
                <Form.Check id="cancellationType-LateCancel" name="LateCancelCancellation" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="LateCancel"
                    type="radio"
                    checked={cancellationType === "LateCancel" ? true : false}
                    onChange={(e) => setCancellationType("LateCancel")}
                  />
                  <Form.Check.Label style={{ marginLeft: 12 }}>Cancellation within 24 hours by Client </Form.Check.Label>
                </Form.Check>
                <Form.Check id="cancellationType-Provider24" name="providerCancellation24" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="providerCancellation24"
                    type="radio"
                    checked={cancellationType === "LateCancelProvider" ? true : false}
                    onChange={(e) => setCancellationType("LateCancelProvider")}
                  />
                  <Form.Label style={{ marginLeft: 12 }}>Cancellation within 24 hours by Provider</Form.Label>
                </Form.Check>
                <Form.Check id="cancellationType-Provider" name="providerCancellation" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="providerCancellation"
                    type="radio"
                    checked={cancellationType === "Provider" ? true : false}
                    onChange={(e) => setCancellationType("Provider")}
                  />
                  <Form.Label style={{ marginLeft: 12 }}>Cancelled</Form.Label>
                </Form.Check>

                {cancellationType !== "" ? (
                  <>
                    {cancellationType === "NoShow" ? (
                      <Form.Label style={{ marginLeft: 12 }}>To cancel please enter information relating to the Client not attending</Form.Label>
                    ) : (
                      <Form.Label style={{ marginLeft: 12 }}>To cancel please enter the reason for cancellation</Form.Label>
                    )}
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="cancellationReason"
                      value={cancellationReason}
                      onChange={(event) => setCancellationReason(event.target.value)}
                      autoComplete="new-password"
                    />
                    {cancellationType === "NoShow" ? (
                      <>
                        <Checkbox
                          aria-label="Send Cancellation SMS"
                          name="cancellationSMS"
                          value={cancellationTypeSMS}
                          onChange={(event) => updateCancellationTypeSMS(event.target.checked)}
                          style={{ paddingTop: 6, paddingLeft: 0 }}
                        />
                        <Form.Label style={{ marginLeft: 12 }}>Do you want to SMS the Client not attending</Form.Label>
                      </>
                    ) : null}
                    {cancellationTypeSMS ? (
                      <>
                        <Form.Label style={{ marginLeft: 12 }}>Please enter the SMS message</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={5}
                          name="cancellationTypeSMSText"
                          value={cancellationTypeSMSText}
                          onChange={(event) => setCancellationTypeSMSText(event.target.value)}
                          autoComplete="new-password"
                        />
                      </>
                    ) : null}
                  </>
                ) : null}
              </Form.Group>
            </Grid>
          </Grid>
        </Modal.Body>
        <Modal.Footer className="new-booking-modal">
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item>
              <Button variant="secondary" size="sm" onClick={() => setShowCancelProviderBooking(false)} className="lightButtonOutlinedLarge">
                Close
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="warning"
                size="sm"
                onClick={() => cancelBooking(cancelBookingData && cancelBookingData.id)}
                disabled={!cancellationReason || (cancellationReason && cancellationReason.replace(/\s/g, "").length < 5)}
                className="lightButtonOutlinedLarge"
              >
                Cancel Booking &gt;
              </Button>
            </Grid>
          </Grid>
        </Modal.Footer>
      </Modal>
    </>
  );
}
